import React from 'react';
import PropTypes from 'prop-types';
import { Circle } from 'rc-progress';
const StatusLoader = _ref => {
  let _ref$loaded = _ref.loaded,
    loaded = _ref$loaded === void 0 ? false : _ref$loaded,
    _ref$percentage = _ref.percentage,
    percentage = _ref$percentage === void 0 ? 0 : _ref$percentage;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "statusLoader"
  }, !loaded && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, "Loading (".concat(percentage, "%)...")), /*#__PURE__*/React.createElement(Circle, {
    percent: percentage,
    strokeWidth: "4",
    strokeColor: "#D3D3D3"
  })));
};
StatusLoader.propTypes = {
  loaded: PropTypes.bool,
  percentage: PropTypes.number
};
export default StatusLoader;